import React, { useEffect, useState } from 'react'
import AvenuChatbot from "../../assets/images/AvenuChatbot.svg";
import { useNavigate } from 'react-router';
import Serachg from "../../assets/images/Search-Icon-grey.svg";
import "../../assets/css/inbox.css";
import "../../assets/css/responsive.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/style.css";

function Resources() {
        const arr=[{
            title:'Create Job with Custom Chatbot Questions ',
            path:'https://scribehow.com/embed/Create_Job_with_Custom_Chatbot_Interface__Od42HyAvQSaCGqBBrXDlug?as=scrollable&removeLogo=true'
        },
        {
            title:'How do I start a job campaign on Talroo? ',
            path:'https://scribehow.com/embed/How_do_I_start_a_job_campaign_on_Talroo__GJeonrD6SMqHLri0M2AxiQ?as=scrollable&removeLogo=true'
        },
        {
            title:'Boost Job with ZipRecruiter',
            path:'https://scribehow.com/embed/Boost_Job_with_ZipRecruiter__LcEfdAPVTu-vryNwWAwzTQ?as=scrollable&removeLogo=true'
        },
        {
            title:'Turn on/off Indeed Apply Integration',
            path:'https://scribehow.com/embed/Turn_on_Indeed_Integration__bcaelck0QX27cKJL0ECAuQ?as=scrollable&removeLogo=true'
        },
        {
            title:'Add New Question to Chatbot',
            path:'https://scribehow.com/embed/Add_New_Question_to_Chatbot__rW1YcfRxQMWBMnAwJ24EAw?removeLogo=true'
        },
        {
            title:'Require Applicants to Submit a Resume',
            path:'https://scribehow.com/embed/Require_Applicants_to_Submit_a_Resume__L0Lpg8dnRb2EgTuxpIo3Gw?removeLogo=true'
        },
        {
            title:'Access invoices on Avenu ',
            path:'https://scribehow.com/embed/Access_invoices_on_Avenu__BCn3RN65RSq5GvmaFG7hVQ?removeLogo=true'
        },
        {
            title:'Create Company Profile on Avenu Platform',
            path:'https://scribehow.com/embed/Create_Company_Profile_on_Avenu_Platform__4OHir-3eSUqA55skzGARzw?as=scrollable&removeLogo=true'
        },
        {
            title:'Candidates Journey for Job Application ',
            path:'https://scribehow.com/embed/Complete_Online_Job_Application_for_Avenuai__C9Dt4ckISkWvOvNjcKJrqQ?removeLogo=true'
        },
        {
            title:'Turn on Indeed Integration ',
            path:'https://scribehow.com/embed/Turn_on_Indeed_Integration__bcaelck0QX27cKJL0ECAuQ?removeLogo=true'
        },
        {
            title:'Indeed Integration - Organic Feed ',
            path:'https://scribehow.com/embed/Indeed_Integration__Organic_Feed__NjP2i1IGQ-e58LN0-bnCZg?removeLogo=true'
        }];
        
        const [resourceArr, setResourceArr]=useState([]);
        const [searchText, setSearchText]=useState('');

        useEffect(()=>{
            const filteredData = arr.filter(item =>
                item.title.toLowerCase().includes(searchText.toLowerCase())
              );
            setResourceArr(filteredData)  
        },[searchText])
const navigate=useNavigate();
  return (

    <div>


    
        <div className="sidebar_open">

        <div className="col-md-12 ">
        <div class="row d-flex align-items-center">
          <div class=" onbording-name-div">
             <li className="list-group-item bordes-div">
              <div className="row d-flex align-items-center">
                <div className=" onbording-name-div col-md-7">
                  <p class="form-name res-tittle my-1">Resources</p>
                </div>
                <div className="search serach-width-div res-div col-md-5">
                  <div className="searchere mb-0 serach-div resours-div">
                    <img
                      src={Serachg}
                      alt="test"
                      className="menu_icon search res-icon"
                    />
                    <input className="form-control border-0 res-search" placeholder="Search...." value={searchText} onChange={(e)=>{setSearchText(e.target.value)}}></input>
                  </div>
                </div>
              </div>
            </li></div></div></div>
    
      <div className='doct-upload-div'>
        <div className='row'>
            {resourceArr.map((item)=>{
                return(
                    <div className='col-lg-4' onClick={()=>{navigate('/dashboard/resource-view', {state:{item}})}} style={{cursor:'pointer'}}>
                    <a className='av-res'>
                    <div className="res-grid">
                            <div className="company-wrp">
                            <img src={AvenuChatbot} alt="left" className="align-icon" />
                                
                                <h3>{item?.title} </h3>
                            </div>
    
                            <ul>
                                <li><span className="steps">8 Steps</span></li>
                                <li>Updated 2 months ago</li>
                            </ul>
                        </div>
                    </a>
                </div>
                )
            })}
           


            {/* <div className='col-lg-4'>
                <a href='#' className='av-res'>
                <div className="res-grid">
                        <div className="company-wrp">
                        <img src={AvenuChatbot} alt="left" className="align-icon" />
                            
                            <h3>Create Job with Custom Chatbot Questions </h3>
                        </div>

                        <ul>
                            <li><span className="steps">8 Steps</span></li>
                            <li>Updated 2 months ago</li>
                        </ul>
                    </div>
                </a>
            </div>
            <div className='col-lg-4'>
                <a href='#' className='av-res'>
                <div className="res-grid">
                        <div className="company-wrp">
                        <img src={AvenuChatbot} alt="left" className="align-icon" />
                            
                            <h3>Create Job with Custom Chatbot Questions </h3>
                        </div>

                        <ul>
                            <li><span className="steps">8 Steps</span></li>
                            <li>Updated 2 months ago</li>
                        </ul>
                    </div>
                </a>
            </div>
            <div className='col-lg-4'>
                <a href='#' className='av-res'>
                <div className="res-grid">
                        <div className="company-wrp">
                        <img src={AvenuChatbot} alt="left" className="align-icon" />
                            
                            <h3>Create Job with Custom Chatbot Questions </h3>
                        </div>

                        <ul>
                            <li><span className="steps">8 Steps</span></li>
                            <li>Updated 2 months ago</li>
                        </ul>
                    </div>
                </a>
            </div>
            <div className='col-lg-4'>
                <a href='#' className='av-res'>
                <div className="res-grid">
                        <div className="company-wrp">
                        <img src={AvenuChatbot} alt="left" className="align-icon" />
                            
                            <h3>Create Job with Custom Chatbot Questions </h3>
                        </div>

                        <ul>
                            <li><span className="steps">8 Steps</span></li>
                            <li>Updated 2 months ago</li>
                        </ul>
                    </div>
                </a>
            </div>
            <div className='col-lg-4'>
                <a href='#' className='av-res'>
                <div className="res-grid">
                        <div className="company-wrp">
                        <img src={AvenuChatbot} alt="left" className="align-icon" />
                            
                            <h3>Create Job with Custom Chatbot Questions </h3>
                        </div>

                        <ul>
                            <li><span className="steps">8 Steps</span></li>
                            <li>Updated 2 months ago</li>
                        </ul>
                    </div>
                </a>
            </div>
            <div className='col-lg-4'>
                <a href='#' className='av-res'>
                <div className="res-grid">
                        <div className="company-wrp">
                        <img src={AvenuChatbot} alt="left" className="align-icon" />
                            
                            <h3>Create Job with Custom Chatbot Questions </h3>
                        </div>

                        <ul>
                            <li><span className="steps">8 Steps</span></li>
                            <li>Updated 2 months ago</li>
                        </ul>
                    </div>
                </a>
            </div>
            <div className='col-lg-4'>
                <a href='#' className='av-res'>
                <div className="res-grid">
                        <div className="company-wrp">
                        <img src={AvenuChatbot} alt="left" className="align-icon" />
                            
                            <h3>Create Job with Custom Chatbot Questions </h3>
                        </div>

                        <ul>
                            <li><span className="steps">8 Steps</span></li>
                            <li>Updated 2 months ago</li>
                        </ul>
                    </div>
                </a>
            </div> */}
        </div>
      </div>
    </div>
    </div>
  )
}

export default Resources